import type React from 'react';
import { Navigate } from 'react-router-dom';
import { PATH } from '@/router/PATH';
import {
    CatalogImportLeaveGuard,
    CatalogImportProvider,
} from '@/pages/catalogImport/store';
import { OnboardingPageView } from './OnboardingPageView';
import { useOnboardingPage } from './useOnboardingPage';

/**
 * `/onboarding/*` — the onboarding wizard, full-screen (no sidebar, no
 * navbar; see `isFullScreenPath`). Each step is a route segment
 * (`PATH.ONBOARDING_STEP`); the bare path, which is where the onboarding gate
 * sends an OrgAdmin, opens Start.
 *
 * One route element serves every step, so the import store mounted here
 * lives across step changes and is dropped when the wizard is left. The
 * leave guard asks first while a parsed file has not been imported.
 */
export const OnboardingPage: React.FC = () => {
    const { isBarePath, ...page } = useOnboardingPage();

    if (isBarePath) {
        return <Navigate replace to={PATH.ONBOARDING_STEP.BIND('start')} />;
    }

    return (
        <CatalogImportProvider>
            <CatalogImportLeaveGuard
                mode="wizard"
                scopePath={PATH.ONBOARDING}
            />
            <OnboardingPageView {...page} />
        </CatalogImportProvider>
    );
};
